import * as React from "react";
import Typography from "@mui/material/Typography";
import COLORS from "theme/tokens/colors";
import { styled } from '@mui/material/styles';

const WarningTypography = styled(Typography)`
  color: ${COLORS.CONTEXT_DANGER_100};
`

export default function MissingCompanyIdWarning() {
  return (
    <>
      <WarningTypography variant="h1">URL Inválida</WarningTypography>
      <Typography variant="body1">
        Não foi possível identificar o parâmetro companyId, por favor verifique o
        endereço acessado.
      </Typography>
    </>
  );
}
